const _circleSizeDelta = 4

export const getAudioPlayerIconsSize = (
  playIconSize: number,
  resumeIconSize: number
) => {
  const circleSize = playIconSize * 2 + _circleSizeDelta
  const resetIconSize = resumeIconSize - _circleSizeDelta
  return { circleSize, resetIconSize }
}
